import { Button, Dialog, DialogActions, DialogContent, Divider, Stack, Typography } from '@mui/material'
import DraggableDialogTitle from '../../../common/DraggableDialogTitle'
import { ExtraSmallButton } from '../../../custom'
import ClearIcon from '../../../../assets/icons/ClearIcon'
import { useNonModalDialog } from '../../../common/useNonModalDialog'
import { useFullscreenContainer } from '../../../../hooks/useFullscreenContainer'
import { WidgetSettingsMenuProvider } from '../../widgetSettingsMenuContext'
import OiSettingsTabs from './OiSettingsTabs'

type Props = {
    open: boolean
    onClose: () => void
    viewKey: string
    expiryMenu: {
        value: string
        label: string
    }[]
    currentSelectedExpiry: {
        expirySeconds: string
        expiry: string
    } | undefined
    onExpiryChange: (selectedExpiry: {
        expirySeconds: string
        expiry: string
    }) => void
}

const OiSettingsDialog = ({
    open,
    onClose,
    viewKey,
    expiryMenu,
    currentSelectedExpiry,
    onExpiryChange,
}: Props) => {
    const fullscreenContainer = useFullscreenContainer()
    const { dialogProps, paperRef } = useNonModalDialog(open, onClose)

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            container={fullscreenContainer ?? undefined}
            {...dialogProps}
            PaperProps={{
                ref: paperRef,
                sx: { minHeight: '40%', maxHeight: 'max-content', pointerEvents: 'auto' },
            }}
        >
            <DraggableDialogTitle>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    <Typography variant="h6">Settings</Typography>
                    <ExtraSmallButton onClick={onClose} aria-label="close" color="inherit">
                        <ClearIcon />
                    </ExtraSmallButton>
                </Stack>
            </DraggableDialogTitle>
            <DialogContent sx={{ padding: 0, display: 'flex', flexDirection: 'column' }}>
                <WidgetSettingsMenuProvider>
                    <OiSettingsTabs
                        viewKey={viewKey}
                        expiryMenu={expiryMenu}
                        selectedExpiry={currentSelectedExpiry}
                        onExpiryChange={onExpiryChange}
                    />
                </WidgetSettingsMenuProvider>
            </DialogContent>
            <Divider />
            <DialogActions>
                <Button variant="contained" onClick={onClose}>
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default OiSettingsDialog
